<template>
  <transition name="ssui-fade">
    <div class="ssui-toast-wrapper" v-show="show">
      <div class="ssui-mask_transparent"></div>
      <div class="ssvue-loading">
        <loading-icon loading color="#fb7a52" size="46" circle-width="20"></loading-icon>
      </div>
    </div>
  </transition>
</template>

<script>
import LoadingIcon from './icon'

export default {
  components: { LoadingIcon },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  created () {
    this.show = this.value
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    value (val) {
      this.show = val
    },
    show (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@finance/ssui/export/ssui.less';

.ssvue-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 3px 15px 0 rgba(175,175,175,0.20);
  transform: translate(-50%,-50%);
  z-index: @loadingZIndex;
}
</style>
